import { render, staticRenderFns } from "@/components/Layout/Menu/AdministradorFlota/Cargas_no_asignadas/Cargas_no_asignadas.html?vue&type=template&id=01bddc0e&scoped=true&"
import script from "@/components/Layout/Menu/AdministradorFlota/Cargas_no_asignadas/Cargas_no_asignadas.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/AdministradorFlota/Cargas_no_asignadas/Cargas_no_asignadas.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/AdministradorFlota/Cargas_no_asignadas/Cargas_no_asignadas.css?vue&type=style&index=0&id=01bddc0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bddc0e",
  null
  
)

export default component.exports